import { render } from "./ServicePage.vue?vue&type=template&id=0a5455c0&scoped=true"
import script from "./ServicePage.vue?vue&type=script&lang=js"
export * from "./ServicePage.vue?vue&type=script&lang=js"

import "./ServicePage.vue?vue&type=style&index=0&id=0a5455c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5455c0"]])

export default __exports__